import { FC, useState } from "react";

import { Button, message } from "antd";

import { refreshAddressFromParcelle } from "../services/collectionItems";

const RefreshAddressBiensOffMarket: FC<{ ids: string[] }> = ({ ids }) => {
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  return (
    <>
      {contextHolder}
      <Button
        style={{ backgroundColor: "#4caf50" }}
        onClick={async () => {
          setLoading(true);
          try {
            // Update addresses for all selected items
            await Promise.all(
              ids.map((id) => refreshAddressFromParcelle(id.toString()))
            );

            messageApi.open({
              type: "success",
              content: `Les adresses ont été mises à jour avec succès pour ${ids.length} élément${ids.length > 1 ? "s" : ""}.`,
            });
            
            // Reload the page to show updated data
            window.location.reload();
          } catch (error: any) {
            console.log(error);
            messageApi.open({
              type: "error",
              content: error.response?.data?.error || "Une erreur est survenue lors de la mise à jour.",
            });
          } finally {
            setLoading(false);
          }
        }}
        disabled={ids.length === 0}
        loading={loading}
      >
        {`Mettre à jour les adresses depuis la parcelle${
          ids.length > 0 ? ` (${ids.length})` : ""
        }`}
      </Button>
    </>
  );
};

export default RefreshAddressBiensOffMarket;
